import styled from "styled-components";

const FooterCopyRightRight = styled.div`
  width: calc(100% - 200px);
  padding-left: 30px;
  color: #ccc;
  font-size: 12px;

  @media (max-width: 575px) {
    width: 100%;
    padding-left: 0;
    text-align: center;
  }
`;

export default FooterCopyRightRight;